<template>
    <div>
        <div class="pl-4 pb-4">
            <div class="d-flex align-items-center">
                <div class="mr-auto">
                    <h3 class="title_usuarioam">{{ $t("message.userActive.title_employee_active") }}</h3>
                </div>
            </div>
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="#">
                            <router-link :to="{ name: 'home'}" data-vs-link="to-home">
                                {{$t('message.home')}}
                            </router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item"><a href="#">
                            <router-link :to="{ name: 'employeeslist'}" data-vs-link="to-employee-list">
                                {{$t('message.employees_list_result') | capitalize}}
                            </router-link>
                        </a>
                    </li>
                    <li class="breadcrumb-item active" aria-current="page">{{nombre}}</li>
                </ol>
            </nav>
        </div>
    </div>
</template>
<script>
import { Component, Prop, Vue } from "vue-property-decorator";

export default {
    components: {
    },
    props: {
        nombre:''
    },
    data() {
        return {
        };
    },
    created(){
       
    },
    methods: {
      
    }
}
</script>

<style scoped lang="scss">
@import "./public/assets/scss/components/_usuarioam.scss";
</style>
